//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import trackingParamsTemplate from '@partials/tracking-params/tracking-params.html';

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('trackingParams', () => ({
    restrict: 'E',
    scope: { },
    template: trackingParamsTemplate,
    controller: 'TrackingParamsController',
    controllerAs: 'ctrl',
  }));
})();
